import { Config } from 'plotly.js';

export const config: Partial<Config> = {
    scrollZoom: false,
    displaylogo: false,
    displayModeBar: true,
    responsive: true,
    modeBarButtonsToRemove: ['toggleSpikelines', 'resetScale2d', 'hoverCompareCartesian', 'hoverClosestCartesian'],
    toImageButtonOptions: {
        format: 'svg',
        scale: 1,
    }
}

export const layout_tsne_umap_pca: () => Partial<Plotly.Layout> = function() {
    
    return {
        responsive: true,
        autosize: true,
        showlegend:false,
        margin: {
        l: 30,
        r: 10,
        b: 30,
        t: 60,
        pad: 0
        },
        modebar: {
        color: '#555555',
        activecolor: '#315FB5',
        },
    }
};